import React from "react";
import "./Icon.css";

// Draws a Font Awesome icon definition (e.g. faPhone from
// @fortawesome/free-solid-svg-icons) as inline SVG. Avoids shipping Font
// Awesome's runtime, and the icons are part of the pre-rendered HTML.
const Icon = ({ icon, className }) => {
  const [width, height, , , path] = icon.icon;
  const paths = Array.isArray(path) ? path : [path];
  return (
    <svg
      className={["svg-inline--fa", `fa-${icon.iconName}`, className].filter(Boolean).join(" ")}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      {paths.map((d) => (
        <path key={d} fill="currentColor" d={d} />
      ))}
    </svg>
  );
};

export default Icon;
